<template>
    <div class="py-3">
        <b-alert v-if="error" show variant="danger" class="mb-3">{{ error }}</b-alert>
        <b-alert v-if="success" show variant="success" class="mb-3">{{ success }}</b-alert>

        <b-form @submit.prevent="submitMerge">
            <div class="row">
                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="transaction_id">Receipt No</label>
                    <b-form-group label-for="transaction_id" class="akkurate-dark">
                        <b-form-input id="transaction_id" class="mt-2 field-container fields" disabled
                            v-model.trim="form.transaction_id" placeholder="Enter source transaction id"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block" for="destLoan">Destination Loan
                        Number</label>
                    <b-form-group label-for="destLoan" class="akkurate-dark">
                        <b-form-input id="destLoan" class="mt-2 field-container fields" v-model.trim="form.loan_number"
                            placeholder="Enter destination loan number"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-4">
                    <label class="akkurate-dark small d-none d-lg-block">&nbsp;</label>
                    <div class="d-grid gap-2 d-flex align-content-center justify-content-start mt-2">
                        <b-button type="submit" :disabled="isMerging"
                            class="akkurate-green-btn akkurate-auth-size d-flex align-items-center">
                            <font-awesome-icon v-if="!isMerging" :icon="['fas', 'object-group']" class="me-2" />
                            <b-spinner v-else small class="me-2" />
                            <span>Transfer</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form>

        <hr />
        <div class="small text-muted">
            Notes:
            <ul class="mb-0">
                <li>The transaction (receipt) from the source will be moved and attached to the destination loan.</li>
                <li>All transaction-related items (repayments, schedules, allocations) will be transferred to the
                    destination loan.</li>
                <li>Destination loan balances and paid totals will be recalculated after the transfer.</li>
                <li>An audit log of the transfer will be kept and the original receipt number will be preserved.</li>
            </ul>
        </div>
    </div>
</template>


<script>
import ApiService from '@/core/services/api.service';

export default {
    name: 'LoanMerge',
    data() {
        return {
            form: {
                transaction_id: this.transaction_id,
                loan_number: '',
            },
            isMerging: false,
            error: '',
            success: ''
        }
    },
    props: ['transaction_id'],
    // mounted() {
    //     const ln = this.$route?.query?.loan_number;
    //     if (ln) {
    //         this.form.source_loan_number = ln;
    //     }
    // },
    methods: {
        async submitMerge() {
            this.error = '';
            this.success = '';
            if (!this.form.transaction_id || !this.form.loan_number) {
                this.error = 'Please enter both source and destination loan numbers.';
                return;
            }
            if (this.form.transaction_id === this.form.loan_number) {
                this.error = 'Source and destination loan numbers must be different.';
                return;
            }
            try {
                this.isMerging = true;

                swal.fire({
                    title: "Please confirm",
                    html: `Are you sure you want to <strong>Tranfer</strong> Transaction ID - : <strong>${this.transaction_id}</strong> Into Loan : <strong>${this.form.loan_number}</strong>`,
                    icon: "info",
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    showCancelButton: true, // Show the "Cancel" button
                    confirmButtonText: "Transfer", // Customize the text for the "OK" button
                    cancelButtonText: "No", // Text for the custom button
                    buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                    customClass: {
                        confirmButton:
                            "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        cancelButton:
                            "btn btn-size akkurate-gray-btn modal-btn-width text-white", // Custom class for the custom button
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$Progress.start();
                        const { data } = await ApiService.post('/loans/transferLoanTransaction', {
                            id: this.form.transaction_id,
                            loan_number: this.form.loan_number,
                        });
                        if (data?.status === 'success') {
                            this.success = data?.message || 'Loans Transfer successfully';
                            this.$bvToast && this.$bvToast.toast(this.success, { variant: 'success', autoHideDelay: 4000 });
                            this.$emit('loanTransfered');
                        } else {
                            throw new Error(data?.message || 'Failed to Transfer loans');
                        }
                    }
                });
            } catch (e) {
                const msg = e?.response?.data?.message || e?.message || 'Failed to Transfer loans';
                this.error = msg;
                this.$bvToast && this.$bvToast.toast(msg, { variant: 'danger', autoHideDelay: 5000 });
            } finally {
                this.isMerging = false;
            }
        }
    }
}
</script>